module.exports = "<div class=\"editable-field\">\n    <input class=\"editable-input\" type=\"text\" ng-trim=\"true\" placeholder=\"Enter Name\" ng-keyup=\"$ctrl.handleSubmit($event)\" ng-blur=\"$ctrl.handleSubmit($event)\" ng-model=\"$ctrl.newValue\" />\n</div>\n<div class=\"editable-text\" ng-click=\"$ctrl.setEditMode(true)\" ng-bind=\"$ctrl.newValue || $ctrl.name\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/components/fb-editable/fb-editable.html
// module id = 812
// module chunks = 3